<template>
	<div class="center">
		<div class="introduce" ref="introduce">
			<div class="introduce-text">
				<div class="title">
					广州数源畅联科技有限公司（Linkstor）是一家专注于数据领域与科技服务的高新技术企业
				</div>
				<div class="middle-divider" />
				<div class="text">
					数源畅联自2017年创立以来，致力于推进数字化技术的创新服务，围绕数据安全、连接安全、智能服务、物联网四大产品方向，形成容灾、备份、迁移、网络安全连接、私有云建设、物联网等产品及专业服务，服务范围涵盖运营商、医疗、教育、政务等多领域，并获得了市场的一致认可！
				</div>
				<div class="text">
					数源畅联一直坚持创新突破的中心理念，将技术研发和人才培养作为发展目标。在公司本部设立了专门的研发部及技术部门，且在上海、四川、武汉建立了长期稳定的合作研发团队，以自主研发创新的产品和技术服务为客户提供数据领域要素的解决方案，帮助客户从容应对数字化转型的业务挑战。
				</div>
				<div class="text">
					未来，数源畅联仍秉持不断创新驱动变革的发展理念，以技术引领发展，为客户提供专业、高效、优质的服务！
				</div>
			</div>
			<div class="introduce-img">
				<img class="introduce-main" :src="introduceImg">
			</div>
		</div>
		<!-- <div class="mountain" ref="mountain">
      <img class="mountain-img" :src="mountain"/>
    </div> -->
		<div class="certificate">
			<div class="title">
				荣誉资质
			</div>
			<div class="honor" ref="honor">
				<!--图片轮播图--start-->
				<div class="imgWatch">
					<el-carousel class="carousel-main" ref="carousel" :autoplay="true" type="card"
						indicator-position="none" arrow="never" height="100%">
						<el-carousel-item v-for="item in certificates" :key="item">
							<!--              <h3 class="medium">{{ item }}</h3>-->
							<img class="aptitudeCertificate_img" :width="item.width" :height="item.height"
								:src="item.credentials" />
						</el-carousel-item>
					</el-carousel>
					<el-button class="last" @click="last">&lt;</el-button>
					<el-button class="next" @click="next">&gt;</el-button>
				</div>
				<!--图片轮播图--end-->
				<div class="honor-list">
					<el-tabs v-model="active" :stretch="true">
						<el-tab-pane label="资质" name="aptitude">
							<el-timeline class="timeline">
								<el-timeline-item v-for="(activity, index) in aptitudeActivities"
									:key="index" :timestamp="activity.timestamp"
									:color="activity.color">
									{{ activity.content }}
								</el-timeline-item>
							</el-timeline>
						</el-tab-pane>
						<!-- <el-tab-pane label="软著" name="Softness">
              <el-timeline class="timeline">
                <el-timeline-item
                    v-for="(activity, index) in softnessActivities"
                    :key="index"
                    :timestamp="activity.timestamp"
                    :color="activity.color">
                  {{activity.content}}
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
            <el-tab-pane label="荣誉" name="honor">
              <el-timeline class="timeline">
                <el-timeline-item
                    v-for="(activity, index) in honorActivities"
                    :key="index"
                    :timestamp="activity.timestamp"
                    :color="activity.color">
                  {{activity.content}}
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane> -->
					</el-tabs>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "index",
	data() {
		return {
			introduceImg: require('../../assets/about/introduceImg.png'),
			active: 'aptitude',
			aptitudeActivities: [
				{
					content: '高新技术企业证书',
					timestamp: '2022年12月',
					color: '#70a840'
				},
				{
					content: '信息系统建设和服务能力CS1级',
					timestamp: '2023年08月',
					color: '#70a840'
				},
				{
					content: '信息系统建设和服务能力CS1级-副本1',
					timestamp: '2023年08月',
					color: '#70a840'
				},
				{
					content: '信息系统建设和服务能力CS1级-副本2',
					timestamp: '2023年08月',
					color: '#70a840'
				},
				{
					content: 'ccrc三级信息安全服务资质认证证书',
					timestamp: '2024年02月',
					color: '#70a840'
				},
				{
					content: 'ccrc三级信息安全服务资质认证证书',
					timestamp: '2024年02月',
					color: '#70a840'
				},
				{
					content: 'ISO20000-信息技术服务管理体系认证证书',
					timestamp: '2025年04月',
					color: '#70a840'
				},
				{
					content: 'ISO 27001-信息安全管理体系认证证书',
					timestamp: '2025年05月',
					color: '#70a840'
				},
				{
					content: 'ISO27017-云服务信息安全管理体系认证证书',
					timestamp: '2025年05月',
					color: '#70a840'
				},
				{
					content: 'ISO27018-公有云中个人可识别信息保护管理体系认证证书',
					timestamp: '2025年05月',
					color: '#70a840'
				},
				{
					content: 'ISO14001-环境管理体系认证证书',
					timestamp: '2025年06月',
					color: '#70a840'
				},
				{
					content: 'ISO 9001-质量管理体系认证证书',
					timestamp: '2025年07月',
					color: '#70a840'
				},
				{
					content: '增值电信业务经营许可证-增国内多方通信服务业务',
					timestamp: '2025年07月',
					color: '#70a840'
				},
				{
					content: 'CMMI三级认证证书',
					timestamp: '2025年08月',
					color: '#70a840'
				},


			],
			aptitudeCertificate: [
				{
					credentials: require('@/assets/about-center/gaoxinjishu.jpg'),
					width: '100%',
					height: '60%',
				},
				{
					credentials: require('@/assets/about-center/xinxijianshe1.png'),
					width: '100%',
					height: '60%',
				},
				{
					credentials: require('@/assets/about-center/xinxijianshe2.png'),
					width: '100%',
					height: '60%',
				},
				{
					credentials: require('@/assets/about-center/xinxijianshe3.png'),
					width: '100%',
					height: '60%',
				},
				{
					credentials: require('@/assets/about-center/ccrc.jpg'),
					width: '90%',
					height: '100%',
				},
				{
					credentials: require('@/assets/about-center/ISO20000.png'),
					width: '100%',
					height: '100%',
				},

				{
					credentials: require('@/assets/about-center/ISO27001.png'),
					width: '100%',
					height: '98%',
				},
				{
					credentials: require('@/assets/about-center/ISO27017.png'),
					width: '100%',
					height: '98%',
				},
				{
					credentials: require('@/assets/about-center/ISO27018.jpg'),
					width: '100%',
					height: '98%',
				},
				{
					credentials: require('@/assets/about-center/ISO14001.png'),
					width: '100%',
					height: '100%',
				},
				{
					credentials: require('@/assets/about-center/ISO9001.png'),
					width: '100%',
					height: '100%',
				},
				{
					credentials: require('@/assets/about-center/xuke1.png'),
					width: '100%',
					height: '100%',
				},
				{
					credentials: require('@/assets/about-center/CMMI.png'),
					width: '100%',
					height: '100%',
				},
			],

			mountain: require('../../assets/about/mountain.png'),
		}
	},
	mounted() {
		if (this.$route.params) {
			if (this.$route.params.id == 'introduce') {
				this.$refs.introduce.scrollIntoView({
					behavior: "smooth",  // 平滑过渡
					block: "start"  // 上边框与视窗顶部平齐。默认值
				});
			} else if (this.$route.params.id == 'mountain') {
				this.$refs.mountain.scrollIntoView({
					behavior: "smooth",  // 平滑过渡
					block: "start"  // 上边框与视窗顶部平齐。默认值
				});
			} else if (this.$route.params.id == 'honor') {
				this.$refs.honor.scrollIntoView({
					behavior: "smooth",  // 平滑过渡
					block: "start"  // 上边框与视窗顶部平齐。默认值
				});
			}
		}
	},
	methods: {
		last() {
			this.$refs.carousel.prev()
		},
		next() {
			this.$refs.carousel.next()
		}
	},
	computed: {
		certificates() {
			let certificate = [];
			if (this.active === 'aptitude') {
				certificate = this.aptitudeCertificate;
			} else if (this.active === 'Softness') {
				certificate = this.softnessCertificate;
			} else if (this.active === 'honor') {
				certificate = this.honorCertificate;
			}
			return certificate;
		}
	}
}
</script>

<style lang="scss" scoped>
.introduce {
	margin-top: 80px;
	width: 1920px;
	height: 783px;
	display: flex;
	justify-content: center;

	.introduce-text {
		display: flex;
		flex-direction: column;
		justify-content: center;

		.title {
			width: 704px;
			height: 84px;
			opacity: 1;
			/** 文本1 */
			font-size: 32px;
			font-weight: 400;
			letter-spacing: 0px;
			line-height: 42px;
			color: rgba(102, 102, 102, 1);
			text-align: left;
			vertical-align: top;
		}

		.middle-divider {
			margin-top: 30px;
			width: 73px;
			height: 14px;
			opacity: 1;
			border-radius: 7px;
			background: linear-gradient(270deg, rgba(13, 126, 191, 1) 0%, rgba(112, 168, 64, 1) 100%);
		}

		.text {
			margin-top: 30px;
			width: 703.1px;
			height: 100px;
			/** 文本1 */
			font-size: 18px;
			font-weight: 300;
			letter-spacing: 0px;
			line-height: 26.06px;
			color: rgba(102, 102, 102, 1);
			text-align: left;
			vertical-align: top;

		}
	}

	.introduce-img {
		margin-left: 30px;

		.introduce-main {
			width: 668px;
			height: 783px;
		}
	}
}

.mountain {
	margin-top: 80px;
	width: 1920px;
	height: 883px;

	.mountain-img {
		width: 1920px;
		height: 883px;
	}
}

.certificate {
	width: 1920px;
	height: 800px;
	display: flex;
	flex-direction: column;
	justify-content: left;

	.title {
		margin-left: 350px;
		margin-top: 80px;
		width: 144px;
		height: 53px;
		/** 文本1 */
		font-size: 36px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 52.13px;
		color: rgba(51, 51, 51, 1);
		text-align: left;
		vertical-align: top;
	}

	.honor {
		margin-top: 30px;
		display: flex;
		justify-content: center;

		.imgWatch {
			width: 800px;
			height: 510px;

			.carousel-main {
				width: 800px;
				height: 510px;
			}

			.last {
				width: 48px;
				height: 48px;
				opacity: 1;
				background: rgba(13, 126, 191, 1);
				font-weight: 800;
				color: white;
			}

			.next {
				width: 48px;
				height: 48px;
				opacity: 1;
				background: rgba(13, 126, 191, 1);
				font-weight: 800;
				color: white;
			}

			//.el-carousel__item:nth-child(2n) {
			//  background-color: #99a9bf;
			//}
			//.el-carousel__item:nth-child(2n+1) {
			//  background-color: #d3dce6;
			//}
		}

		.honor-list {
			width: 400px;
			margin-left: 50px;
			text-align: left;

			.timeline {
				overflow-y: scroll;
				height: 500px;
				margin-top: 20px;
				margin-left: 40px;
			}
		}
	}
}

//.aptitudeCertificate_img{
//	width: 100%;
//	height: 100%;
//}</style>